module.exports = __webpack_public_path__ + "static/img/ngo.4905d0d8.png";